
export default {
    name: "AddProtocol",
    data() {
        return {
            addProtocolForm: {
                // 协议类型  1：收单服务协议  2：出单服务协议  3：业务关系协议 4:提单协议
                type: '',
                // 协议名称
                protocolName: '',
                // 协议文件
                // file: '',
                fileList: [],
                // 中英文版本 1：中文  2：英文
                lang: '',
                // 协议内容
                protocolContent : ''
            },
            protocolRaw: null
        }
    },
    mounted: function () {
    },
    created() {
        this.conditionData = this.$routerUtil.getParam();
    },
    computed: {
        rules() {
            return {
                protocolName: [
                    { required: true, message: this.$t('p_protocolManage.message.protocolName'), trigger: 'blur' },
                    { max: 100, message: this.$t('p_protocolManage.message.tooLong') + 100, trigger: 'blur' }
                ],
                type: [
                    { required: true, message: this.$t('p_protocolManage.message.type'), trigger: 'change' },
                ],
                lang: [
                    { required: true, message: this.$t('p_protocolManage.message.lang'), trigger: 'change' }
                ],
                fileList: [
                    { required: true, message: this.$t('p_protocolManage.message.file'), trigger: 'change' }
                ]
            }
        },
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const param = Object.assign({}, this.addProtocolForm);
                    delete param.fileList;
                    param.upfile = this.protocolRaw;
                    const formData = new FormData();
                    for(let key of Object.keys(param)){
                        formData.append(key, param[key]);
                    }
                    this.$axios({
                        url: '/api/protocol/insertProtocol', 
                        method: 'POST', 
                        // 请求头，发送FormData格式的数据，必须是 这种请求头。
                        headers: {  'Content-Type': 'multipart/form-data;charset=UTF-8' }, 
                        data: formData, 
                    }).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.back();
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    });
                }
            });
        },
        back() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.back();
        },
        // 重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.addProtocolForm.fileList = fileList;
        },
        handlePreview(file) {
            console.log(file);
        },
        beforeRemove(file) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        fileChange(file, fileList) {
            this.addProtocolForm.fileList = fileList;
            this.protocolRaw = file.raw;
        }
    }
}
